// Module
var code = "<div class=\"layout-column layout-align-center-center\" mn-bind-html=\"stand-alone/image-edition/views/actions.tpl.html\"></div>\n\n<div class=\"canvas flex\"></div>\n\n<md-content mn-bind-html=\"stand-alone/image-edition/views/options.tpl.html\"></md-content>\n";
// Exports
module.exports = code;